import { markRaw } from 'vue'
import type { RegisteredComponent } from '@builder.io/sdk-vue'
import FormContactUs from '~/components/FormContactUs.vue'

export default <RegisteredComponent>{
  name: 'FormContactUs',
  tag: 'form-contact-us',
  component: markRaw(FormContactUs),
  inputs: [
    {
      name: 'blogPosts',
      type: 'list',
      friendlyName: 'List of blog posts to show (bound data)',
      helperText:
        'This is the list of blog posts from the Blog Post model. Make sure to bind it through Visual Editor',
      defaultValue: [
        {
          title: 'What is Lorem Ipsum?',
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          link: 'https://google.com',
          image: 'https://picsum.photos/200/300',
          tags: ['tag1', 'tag2'],
        },
      ],
      subFields: [
        { name: 'title', type: 'string' },
        { name: 'description', type: 'string' },
        {
          name: 'link',
          type: 'string',
        },
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg', 'webp'],
        },
        { name: 'tags', type: 'list' },
      ],
    },
  ],
}
